import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { BlurLinearIcon } from '../../../../atoms/material-icons';
import { fetchStockId } from '../../utils/marketsUtils';
import EmptyState from '../empty-state';
import { useInterval } from '../../../../../helpers/custom-hooks';
import { isWithinTradingHours } from '../../../../../helpers/utils';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import './delivery-volumes.m.css';

const DeliveryVolumes = () => {
  const [deliveryVolData, setDeliveryVolData] = useState({});
  const [initialLoading, setInitialLoading] = useState(true);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getDeliveryVolumeData = async () => {
    const retrievedStockId = fetchStockId();
    const response = await fetch(`/next/feapi/stock/delivery-volumes/${retrievedStockId}`);
    const data = await response.json();
    setDeliveryVolData(data?.data);
  };

  useEffect(() => {
    if (initialLoading) {
      getDeliveryVolumeData();
      setInitialLoading(false);
    }
  }, []);

  useInterval(() => {
    if (isWithinTradingHours(tradingHolidays, specialTradingDays)) {
      getDeliveryVolumeData();
    }
  }, 30000);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="delivery-vol-container">
      <div styleName="header-title-container">
        <BlurLinearIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">Delivery Volumes</h2>
      </div>
      {!deliveryVolData || isEmpty(deliveryVolData) ? (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState subTextMessage={'for this stock at the moment'} />
          </div>
        </div>
      ) : (
        <>
          <div>
            {deliveryVolData?.header?.map((delivery, index) =>
              delivery.dir > 0 ? (
                <div styleName="delivery-volumes" key={index}>
                  <div>
                    <span className="icon-ic_lightbulb" />
                    <span>ADVANCES</span>
                  </div>
                  <span>{delivery.msg}</span>
                </div>
              ) : (
                <div styleName="delivery-volumes-negative" key={index}>
                  <div>
                    <span className="icon-ic_lightbulb" />
                    <span>DECLINES</span>
                  </div>
                  <span>{delivery.msg}</span>
                </div>
              ),
            )}
          </div>
          <div styleName="delivery-volumes-body">
            <table>
              <tr>
                <th>Description</th>
                <th>Volume Average</th>
                <th>Volume Percentage</th>
              </tr>
              {deliveryVolData?.tableDetails?.map((detail, index) => (
                <tr key={index}>
                  <td styleName="detail-text">{detail?.text}</td>
                  <td>{detail?.volumeAverage}</td>
                  <td>{detail?.percentage}</td>
                </tr>
              ))}
            </table>
          </div>
          <div styleName="footer-container">
            <ul>
              {deliveryVolData?.footer?.map((text, index) => (
                <li styleName="footer-text" key={index}>
                  {text}
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default DeliveryVolumes;
